import type { PRICING_DATA, PRICING_PARAMS } from './types'
import { DEFAULT_BLOCK_LINK } from '../_shared/link/types'

export const DEFAULT_PRICING_DATA = (): PRICING_DATA => ({
  id: null,
  classes: null,
  styles: null,
  type: 'pricing',
  heading: 'Členství MD Club',
  eyebrow: 'Roční členství',
  price: '5 000 Kč',
  period: 'za rok – obnovení po potvrzení',
  discountNote: null,
  features: [
    { icon: '/img/icons/databaze-icon.svg', label: 'Databáze realizací' },
    { icon: '/img/icons/partnerskeslevy-icon.svg', label: 'Partnerské slevy' },
    { icon: '/img/icons/sleva-icon.svg', label: 'Sleva 10 % na konzultaci' },
    { icon: '/img/icons/novyobsah-icon.svg', label: 'Nový obsah celý rok' },
    { icon: '/img/icons/vykresy-icon.svg', label: 'Výkresy detailů' },
    { icon: '/img/icons/odpovedi-icon.svg', label: 'Odpovědi od Martiny' },
  ],
  ctaLabel: 'Chci být členem',
  ctaLink: DEFAULT_BLOCK_LINK(),
  fineprint: 'Min. délka 1 rok. Bez možnosti vrácení platby.',
})

export const DEFAULT_PRICING_PARAMS = (): PRICING_PARAMS => ({
  pc: { hidden: false },
  tablet: { hidden: false },
  mobile: { hidden: false },
})
